import { observer } from 'mobx-react-lite';

import GroupPage from './GroupPage';
import { GroupPageProps, GroupPageValueProps } from './types';

export type { GroupPageProps, GroupPageValueProps };
export default observer(GroupPage); // MANUAL OVERRIDE
